import { cellphone } from '@/helpers/formatters/cellphone'
import { cpf } from '@/helpers/formatters/cpf'
import { formatDocument } from '@/helpers/formatters/document'
import { currency } from '@/helpers/formatters/currency'
import { eventName } from './eventName'
import { fromSQL } from './date'
import { payment, type StatusInfo } from '@/helpers/formatters/payment'
import type { App } from 'vue'
import Event from '@/types/Event'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $formatters: {
      eventName(value: Event): string
      currency(value: number): string
      cellphone(value: string): string
      cpf(value: string): string
      document(value: string | undefined, documentType?: 'cpf' | 'passport'): string
      date: {
        fromSQL(value: string, format?: string): string
      }
      payment(status: string): StatusInfo
    }
  }
}

export function register(app: App) {
  app.config.globalProperties.$formatters = {
    eventName: eventName,
    currency: currency,
    cellphone: cellphone,
    cpf: cpf,
    document: formatDocument,
    date: {
      fromSQL: fromSQL,
    },
    payment: payment,
  }
}
